import css from 'styled-jsx/css'
import { colors, grids } from '../../styles'
import { transparentize } from '../../utils/colors'
import columns from '../../utils/columns'

const just1colhuge = columns({
  cols: 1,
  grid: 'superWide',
  totalCols: 1,
})

export default css`
.CardRefresh {
  display: block;
  margin-bottom: 16px;
  margin-right: ${grids.narrow.margin}px;
  position: relative;
  /* transition z-index on hover so hovered card appears above other cards */
  z-index: 1;
  transition: 400ms z-index;
  transition-delay: 0;
}

.sponsor{
  position: absolute;
  top: 10px;
  right: 1%;
}


.CardRefresh.special-event {
  width: 100%;
  min-width: 100%;
}

.CardRefresh.stacking{
  display: flex;
  width: 100%;
  margin-left: ${grids.narrow.margin}px;
}

.CardRefresh.specialEvent {
  grid-template-columns: 1fr 1 fr 1fr 1fr;
  grid-template-rows: 1fr;
  width: ${just1colhuge};
  max-width: 1920px;
  margin: 0px;

}

.iconWrap{
  padding-top: 8px;
  display: flex;
  align-items: center;
}

a, a:visited {
  color: inherit;
}

a:hover, a:focus {
  color: ${colors.textHoverPurple};
}

a::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: block;
  z-index: 2;
}

span {
  content: '';
  position: absolute;
  top: 0;
  bottom: -10px;
  left: 17%;
  right: 0;
  display: block;
  z-index: 2;
  background: linear-gradient(90deg, #151515 0%, #151515 10%, rgba(21, 21, 21, 0) 55.31%), linear-gradient(0deg, #151515 0%, rgba(21, 21, 21, 0) 49.84%);
}

figure {
  margin: 0 0 0px;
  position: relative;
  transition: 100ms transform;
  transform-origin: center;
  transform: scale(1.00000001); /* avoid child elements flickering when transform starts */
  backface-visibility: hidden;
  will-change: transform;
  background: ${colors.baseBg};
  border-radius: 8px;
}

.hero-cta-wrapper {
  position: absolute;
  padding-top: 24%;
  bottom: 42%;
  left: 16px;
  z-index: 1000;
  max-width: 527px;
}

.hero-cta-wrapper-program{
  position: absolute;
  padding-top: 24%;
  bottom: 42%;
  left: 16px;
  z-index: 1000;
  max-width: 527px;
}

.hero-cta-wrapper.animationend{
  animation-fill-mode: forwards;
  animation-delay: 10ms;
  animation: dissolve;
  animation-timing-function: ease-out;
  animation-duration: 800ms;
}

@-webkit-keyframes dissolve {
  100% {
    transform: translateX(0);}
  0% {
    transform: translateX(100%);}
}
@keyframes dissolve {
  100% {
    transform: translateX(0);}
  0% {
    transform: translateX(100%); }
}

.faded figure{
  opacity: 0.5;
}

.stacking figure{
  max-width: 108px;
  margin-right: 16px;
}

figcaption {
  position: absolute;
  left: 0;
  background: ${transparentize(colors.IconButtonPurple, 0.8)};
  padding: 4px 8px;
  bottom: 0;
  border-radius: 0px 0px 0px 8px;
}

.figure-overlay-program{
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  flex-direction: column;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(21, 21, 21, 0) 75%, rgba(21, 21, 21, 0.85) 100%);
}

.figure-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 4px;
  bottom: 4px;
  transform: scale(1.00001); /* avoid child elements flickering when transform starts */
  border-radius: 8px;
}
.figure-overlay-cw{
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 4px;
  bottom: 4px;
  display: flex;
  flex-direction: column;
  transform: scale(1.00001); /* avoid child elements flickering when transform starts */
  border-radius: 8px;
  align-items: flex-start;
  padding: 0px 8px 0px 8px;
  width: 100%;
}

.CardRefresh.specialEvent figure {
  transform: none;
}

.preview-image.hidden {
  z-index: 1;
  -webkit-animation: 1.5s ease 0s normal forwards 1 fadeout;
    animation: 1.5s ease 0s normal forwards 1 fadeout;
}

@keyframes fadeout{
  0% { opacity:1; }
  66% { opacity:1; }
  100% { opacity:0; }
}

@-webkit-keyframes fadeout{
  0% { opacity:1; }
  66% { opacity:1; }
  100% { opacity:0; }
}

@media (hover: hover) {
  .CardRefresh:hover {
    border-radius: 8px;
  }

  .CardRefresh:not(.specialEvent):hover {
    z-index: 2;
  }

  .CardRefresh:not(.specialEvent):hover figure {
    transform: scale(1.055);
  }

  .CardRefresh.episode:hover figure {
    transform: scale(1.06)
  }
  .CardRefresh.tabCard:hover figure{
    border: 2px solid rgba(246, 246, 246, 0.5);
    box-shadow: 0px 0px 8px #fff;
    transform: none !important;
  }
  .CardRefresh.no-scale:hover figure {
    transform: none !important;
  }
  a:hover .figure-overlay-program{
    opacity: 1;
  }
}

:global(.ie) .CardRefresh:hover {
  z-index: 2;
}

:global(.ie) .CardRefresh:hover figure {
  transform: scale(1.055);
}

:global(.ie) .CardRefresh.no-scale:hover figure {
  transform: none !important;
}

@media (min-width: 768px) {
  figure {
    display: grid;
  }

  .preview-image {
    grid-column-start: 1;
    grid-column-end: 4;
    grid-row-start: 1;
    z-index: 2;
  }

  .preview-player {
    grid-column-start: 1;
    grid-column-end: 4;
    grid-row-start: 1;
  }


.hero-cta-wrapper-program{
  bottom: 20%!important;
  left: 24px;
}
.CardRefresh.specialEvent figure {
  transform: none;
}
.CardRefresh.programHead figure {
  min-height: auto;
  transform: none;
}
span {
  bottom: -5px;
}
}

@media (max-width: 1199px) {
  .hero-cta-wrapper {
    position:fixed;
    padding-left: 8px;
    padding-right: 8px;
    left: 0px;
    width: 56%;
    max-width: 100%;
    z-index: 10000;
    top: calc(25% + 5em);
    padding-top: 0;
  }

  span.Home {
    left: 0;
  }

  .CardRefresh.specialEvent figure {
    // min-height: unset;
  }
}

@media (max-width: 767px) {
  .CardRefresh.tabCard {
    width: 300px;
    min-width: 300px !important;
  }

  .hero-cta-wrapper {
    padding-right: 8px;
    padding-left: 0px;
    bottom: 0px;
    left: 0px;
    width: 100%;
    padding-top: 43%;
  }

  .hero-cta-wrapper-program{
    position:relative;
    padding-left: 16px;
    padding-right: 16px;
    margin-top: -230px;
    left: 0px;
    width: 100%;
    max-width: 100%;
    z-index: 10000;
  }
  .CardRefresh.specialEvent{
    height: auto;
  }
  .CardRefresh.specialEvent figure {
    min-height: 420px;
  }
  .CardRefresh.programHead figure span {
    bottom: 110px !important;
    left: 0px !important;
  }
  span, span.Home {
    background: linear-gradient(0deg, #151515 15.1%, rgba(21, 21, 21, 0.4) 44.4%, rgba(21, 21, 21, 0.1) 100%);
  }
}

@media (max-width: 649px) {
  .hero-cta-wrapper {
    padding-top: 24%;
  }
}

@media (max-width: 500px) {
  .hero-cta-wrapper {
    padding-top: 12%;
  }
}

@media (max-width: 1023px) {
  .HoverOverlay {
    display: none;
  }
}

@media (min-width: 1024px) {
  .CardRefresh.specialEvent{
    height: auto !important;
  }
  .hero-cta-wrapper {
    bottom: 50% !important;
  }
  .hero-cta-wrapper-program{
    bottom: 40% !important;
    left: 48px;
  }
  .CardRefresh.categories {
    min-width: 287px;
  }
}

@media (min-width: 1200px) {
  .hero-cta-wrapper {
    position: absolute;
    bottom: 20% !important;
    z-index: 1000;
  }
  .hero-cta-wrapper-program{
    position: absolute;
    bottom: 45% !important;
    left: 48px;
    z-index: 1000;
  }
  span{
    bottom: -10px !important;
  }
}

@media (min-width: 1400px) {
  .hero-cta-wrapper {
    bottom: 30% !important;
  }
}


@media (min-width: 1700px) {
  .hero-cta-wrapper {
    bottom: 40% !important;
  }
  .hero-cta-wrapper-program{
    padding-top: 30%;
    left: 48px;
  }
}

@media (min-width: ${grids.medium.breakpoint}px) {
  @media (hover: hover) {
    .CardRefresh:hover .HoverOverlay  {
      opacity: 1;
      transition: opacity 300ms ease-in-out;
    }
    .CardRefresh:hover .HoverOverlay .border {
      transform: scaleX(1);
      transform-origin: left;
    }
  }

  .CardRefresh:not(.specialEvent):first-of-type {
    margin-left: ${grids.medium.margin}px;
  }
  .CardRefresh.wrapping:nth-of-type(3n+1){
    margin-left: ${grids.medium.margin}px;
  }

  .CardRefresh:not(.specialEvent):last-of-type {
    margin-right: ${grids.medium.margin}px;
  }

  .CardRefresh.categories:last-of-type, .CardRefresh.categories:first-of-type {
    margin-right: 0;
    margin-left: 0;
  }

  .stacking figure{
    max-width: none;
    margin-right: auto;
  }

  .figure-overlay {
    bottom: 16px;
    right: 16px;
  }
.figure-overlay-cw{
  width: 100%;
}
  :global(.CardRefresh .TriangleRightIcon) {
    width: 40px !important;
    height: 40px !important;
  }
}

@media (min-width: ${grids.wide.breakpoint}px) {
  .CardRefresh, .CardRefresh.stacking{
    margin-right: ${grids.wide.gutter}px;
    min-width: 300px;
    width: 260px;
  }

  .CardRefresh.special-event {
    width: 100%;
    min-width: 100%;
  }

  .CardRefresh.large {
    width: 400px;
    min-width: 400px;
  }
  .CardRefresh.tabCard {
    width: 300px;
    min-width: 300px !important;
  }

  .CardRefresh:not(.specialEvent):first-of-type {
    margin-left: ${grids.medium.margin}px;
  }

  .CardRefresh.wrapping:nth-of-type(3n+1){
    margin-left: 0;
  }
  .CardRefresh.wrapping:nth-of-type(4n+1){
    margin-left: ${grids.wide.margin}px;
  }
  .CardRefresh:not(.specialEvent):last-of-type {
    margin-right: ${grids.wide.margin}px;
  }

  .CardRefresh.categories:last-of-type, .CardRefresh.categories:first-of-type {
    margin-right: 0;
    margin-left: 0;
  }
}
`
